import { render, staticRenderFns } from "./Vietin.vue?vue&type=template&id=e89b48d8&scoped=true"
import script from "./Vietin.vue?vue&type=script&lang=js"
export * from "./Vietin.vue?vue&type=script&lang=js"
import style0 from "./Vietin.vue?vue&type=style&index=0&id=e89b48d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89b48d8",
  null
  
)

export default component.exports